import Icon from "@ant-design/icons";
import type { GetProps } from "antd";

// Искри — общоприетият знак за AI. Рисунката е по „sparkles" от Lucide (ISC
// лиценз), с дебелина като на antd Outlined иконите. antd няма такава иконка.
const SparklesSvg = () => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
    <path d="M20 3v4" />
    <path d="M22 5h-4" />
    <path d="M4 17v2" />
    <path d="M5 18H3" />
  </svg>
);

/** Знакът на „AI интеграции" — плочката на „Модули" и модалът към нея. */
export const SparklesIcon = (props: Partial<GetProps<typeof Icon>>) => (
  <Icon component={SparklesSvg} {...props} />
);
